import { useEffect, useState } from "react";
import { LibraryCategory } from "../../interfaces/models/LibraryCategory";
import { Alert, Breadcrumb, BreadcrumbItem, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useLibraryCategories } from '../../graphql/content-management/multi-library/useLibraryCategories';
import Loading from "../Loading";

interface Props {
  modalOpen : boolean;
  toggleModal : () => void;
  onSelect: (category: LibraryCategory) => void;
}

const LibraryParentCategorySelector = ({ onSelect, modalOpen, toggleModal }: Props) => {
  const [currentCategory, setCurrentCategory] = useState<Partial<LibraryCategory>>(null);
  const [categoryBreadcrumbsData, setCategoryBreadcrumbsData] = useState<Partial<LibraryCategory>[]>([{ name: "Library", _id: undefined }]);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState<Partial<LibraryCategory>[]>([]);
  const [selected, setSelected] = useState<Partial<LibraryCategory>>(null);
  
  const { data, loading, refetch } = useLibraryCategories(currentCategory?._id);

  const handleOpen = async (category: LibraryCategory) => {
    if(isLoading || loading) return;
    setIsLoading(true);
    setCurrentCategory(category);
    setCategoryBreadcrumbsData((prev) => [...prev, category]);
    const getCategoriesRaw = await refetch({
      filter: {
        parent_id: category?._id
      }
    });
    if(getCategoriesRaw?.data?.library_categories) {
      setCategories(getCategoriesRaw.data.library_categories);
    }
      setIsLoading(false);
  }

  const handleCrumbsClick = async (category: Partial<LibraryCategory>, index: number) => {
    if(isLoading || loading) return;
    setCurrentCategory(category);
    setCategoryBreadcrumbsData((prev) => prev.slice(0, index + 1));
    setIsLoading(true);
    const getCategoriesRaw = await refetch({
      filter: {
        parent_id: category?._id
      }
    });
    if(getCategoriesRaw.data.library_categories) {
      setCategories(getCategoriesRaw.data.library_categories);
    }

    setIsLoading(false);
  }

  const handleConfirm = () => {
    if(!selected) return;

    onSelect(selected as LibraryCategory);
    toggleModal();

  }

  useEffect(() => {
    if(data?.library_categories) {
      setCategories(data.library_categories);
    }
  },[data]);



 
  return (
    <Modal
      id="multi-library-parent-selector-modal"
      backdrop={true}
      isOpen={modalOpen}
      size="xl"
    >
      
      <ModalHeader toggle={toggleModal} className="pb-0">
          <p className="text-lg">Select Parent Category</p>
      </ModalHeader>
      <ModalBody>
        <Breadcrumb className="breadcrumb-bg-transparent-no-padding">
          {categoryBreadcrumbsData.map((item, key) =>
            key + 1 === categoryBreadcrumbsData.length ? (
              <BreadcrumbItem key={item.name + key + 1} active>
                {item.name}
              </BreadcrumbItem>
            ) : (
              <BreadcrumbItem key={item.name + key} onClick={() => handleCrumbsClick(item, key)} role="button" >
                {item.name}
              </BreadcrumbItem>
            )
          )}
        </Breadcrumb>
        {
          !currentCategory?._id &&
          <div className="p-2 mt-2 border d-flex justify-content-between" >
            <div>
              No Parent
            </div>
            <div>
              <Button size="sm" color={selected?._id === null ? "primary": "secondary"} onClick={() => setSelected({_id: null, name: "No Parent"})}> Select </Button>
            </div>
          </div>
        }
        {
          loading || isLoading ?
          <Loading />
          :
          <>
            {
              (
                categories.length === 0 &&
                <Alert color="primary" >No Categories Found</Alert>
              )
              ||
              categories.map((u, key) => (
                <div className="p-2 mt-2 border d-flex justify-content-between" key={key} >
                  <div>
                    {u.name}
                  </div>
                  <div>
                    <Button size="sm" color="secondary" onClick={() => handleOpen(u as LibraryCategory)}> Open </Button>
                    <Button size="sm" color={selected?._id === u._id ? "primary": "secondary"} onClick={() => setSelected(u)}> Select </Button>
                  </div>
                </div>
              ))
            }

          </>
        }
      </ModalBody>
      <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>Close</Button>
          <Button color="primary" onClick={handleConfirm}>Confirm</Button>
      </ModalFooter>
    </Modal>
      
  )
  
}
export default LibraryParentCategorySelector;